/**
 * Phase 2.12 — Infrastructure Security partial-coverage narrative.
 *
 * When (telecom_v2) AND (Infrastructure Security domain = Not Assessed)
 * AND (related questionnaire responses exist) AND (no dedicated infra
 * controls were assessed), we surface a *coverage* note — never a
 * numeric score, maturity band, or internal control architecture.
 *
 * Scoring-neutral: pure presentation text used by the live Reviewer
 * Console panel and the reviewer PDF report.
 */

/** Reviewer Console / live UI copy. */
export const INFRASTRUCTURE_COVERAGE_NOTE_UI =
  "Infrastructure Security was reviewed for limited in-scope components only. Results should not be interpreted as the organization's full infrastructure security posture.";

/** Reviewer PDF report copy. */
export const INFRASTRUCTURE_COVERAGE_NOTE_PDF =
  "Infrastructure Security was reviewed for limited in-scope components only. Results should not be interpreted as the organization's full infrastructure security posture.";

export const INFRASTRUCTURE_PARTIAL_BADGE = "Scope Incomplete";

export type InfrastructureCoverage = {
  has_related_questionnaire_responses: boolean;
  has_infrastructure_controls_assessed: boolean;
  show_coverage_note: boolean;
};
